import { TFunction } from 'i18next';

import { FeaturedIcon } from '@unified-checkout/design-system';
import {
  ArrowTrendUp,
  CoinStack,
  FileExclamation,
  Wallet,
} from '@unified-checkout/design-system/icons/index';

import { ANALYTICS_CARD_TYPES } from '.';

export const ANALYTIC_CARDS = (t: TFunction) => [
  {
    id: ANALYTICS_CARD_TYPES.TOTAL_TRANSFERS,
    title: t(
      'innerLayout.balanceTransfers.transfers.analyticCards.totalTransfers'
    ),
    tooltipProps: {
      text: t(
        'innerLayout.balanceTransfers.transfers.analyticCards.totalTransfersTooltip'
      ),
    },
    icon: <FeaturedIcon icon={ArrowTrendUp} color="green" size="lg" />,
  },
  {
    id: ANALYTICS_CARD_TYPES.SETTLED,
    title: t('innerLayout.balanceTransfers.transfers.analyticCards.settled'),
    tooltipProps: {
      text: t(
        'innerLayout.balanceTransfers.transfers.analyticCards.settledTooltip'
      ),
    },
    icon: <FeaturedIcon icon={Wallet} color="primary" size="lg" />,
  },
  {
    id: ANALYTICS_CARD_TYPES.IN_PROGRESS,
    title: t('innerLayout.balanceTransfers.transfers.analyticCards.inProgress'),
    tooltipProps: {
      text: t(
        'innerLayout.balanceTransfers.transfers.analyticCards.inProgressTooltip'
      ),
    },
    icon: <FeaturedIcon icon={CoinStack} color="yellow" size="lg" />,
  },
  {
    id: ANALYTICS_CARD_TYPES.FAILED,
    title: t('innerLayout.balanceTransfers.transfers.analyticCards.failed'),
    tooltipProps: {
      text: t(
        'innerLayout.balanceTransfers.transfers.analyticCards.failedTooltip'
      ),
    },
    icon: <FeaturedIcon icon={FileExclamation} color="red" size="lg" />,
  },
];
